/***/
/**
 * Common interfaces for the request-manager-common plugin.
 *
 * @packageDocumentation
 */

export type RequestStatus = 'pending' | 'processing' | 'done' | 'cancelled';

export type RequestType = 'domain-structure' | 'product' | 'component' | 'resource';

export function convertToEntityType(type: RequestType): string {
  switch (type) {
    case 'domain-structure':
      return 'domain';
    case 'product':
      return 'system';
    case 'component':
      return 'component';
    case 'resource':
      return 'resource';
    default:
      return 'Unknown';
  }
}

export interface NewRequestItem {
  status: RequestStatus
  system: string
  owner: string
  name: string
  namespace?: string | undefined
  title?: string | undefined
  description?: string | undefined
  tags?: string[]
  onboarding?: Onboarding
  component?: Component
  resource?: Resource
  entityRef?: string
}

export interface RequestItem {
  id: string
  status: RequestStatus
  system: string
  owner: string
  name: string
  namespace?: string | undefined
  title?: string | undefined
  description?: string | undefined
  tags?: string[]
  onboarding?: Onboarding
  component?: Component
  resource?: Resource
  createdBy: string;
  createdAt: string;
}

export interface ListRequestItem {
  id: string
  status: RequestStatus
  system: string
  owner: string
  name: string
  title?: string | undefined
  createdBy: string;
  createdAt: string;
  type: RequestType;
  onboarding?: Onboarding
  component?: Component
  resource?: Resource
  assetType: string;
}

export interface Onboarding {
  type: string
}

export interface Component {
  type: string
}

export interface Resource {
  type: string
}
